export const BusinessCardScanner = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <path
        d="M10.8695 24.2501H9.6495C7.4995 24.2501 5.7395 22.5001 5.7395 20.3501V19.1201C5.7395 18.5701 6.1895 18.1201 6.7395 18.1201C7.2895 18.1201 7.7395 18.5701 7.7395 19.1201V20.3501C7.7395 21.4001 8.5995 22.2501 9.6495 22.2501H10.8695C11.4195 22.2501 11.8695 22.7001 11.8695 23.2501C11.8695 23.8001 11.4195 24.2501 10.8695 24.2501Z"
        fill="#424242"
      />
      <path
        d="M20.3394 24.2501H19.1194C18.5694 24.2501 18.1194 23.8001 18.1194 23.2501C18.1194 22.7001 18.5694 22.2501 19.1194 22.2501H20.3394C21.3894 22.2501 22.2494 21.4001 22.2494 20.3501V19.1201C22.2494 18.5701 22.6994 18.1201 23.2494 18.1201C23.7994 18.1201 24.2494 18.5701 24.2494 19.1201V20.3501C24.2494 22.5001 22.4994 24.2501 20.3394 24.2501Z"
        fill="#424242"
      />
      <path
        d="M6.74927 11.8702C6.19927 11.8702 5.74927 11.4202 5.74927 10.8702V9.64023C5.74927 7.49023 7.49927 5.74023 9.65927 5.74023H10.8793C11.4293 5.74023 11.8793 6.19023 11.8793 6.74023C11.8793 7.29023 11.4293 7.74023 10.8793 7.74023H9.65927C8.60927 7.74023 7.74927 8.59023 7.74927 9.64023V10.8702C7.74927 11.4202 7.29927 11.8702 6.74927 11.8702Z"
        fill="#424242"
      />
      <path
        d="M23.2494 11.8702C22.6994 11.8702 22.2494 11.4202 22.2494 10.8702V9.64023C22.2494 8.59023 21.3894 7.74023 20.3394 7.74023H19.1194C18.5694 7.74023 18.1194 7.29023 18.1194 6.74023C18.1194 6.19023 18.5694 5.74023 19.1194 5.74023H20.3394C22.4894 5.74023 24.2494 7.49023 24.2494 9.64023V10.8702C24.2494 11.4202 23.7994 11.8702 23.2494 11.8702Z"
        fill="#424242"
      />
      <path
        d="M21.5997 16H8.39966C7.84966 16 7.39966 15.55 7.39966 15C7.39966 14.45 7.84966 14 8.39966 14H21.5997C22.1497 14 22.5997 14.45 22.5997 15C22.5997 15.55 22.1497 16 21.5997 16Z"
        fill="url(#paint0_linear_280_53100)"
      />
      <path
        d="M22.8599 29.8601H7.13989C3.27989 29.8601 0.139893 26.7201 0.139893 22.8601V7.14014C0.139893 3.28014 3.27989 0.140137 7.13989 0.140137H22.8599C26.7199 0.140137 29.8599 3.28014 29.8599 7.14014V22.8601C29.8599 26.7201 26.7199 29.8601 22.8599 29.8601ZM7.13989 2.14014C4.37989 2.14014 2.13989 4.38014 2.13989 7.14014V22.8601C2.13989 25.6201 4.37989 27.8601 7.13989 27.8601H22.8599C25.6199 27.8601 27.8599 25.6201 27.8599 22.8601V7.14014C27.8599 4.38014 25.6199 2.14014 22.8599 2.14014H7.13989Z"
        fill="#424242"
      />
      <defs>
        <linearGradient
          id="paint0_linear_280_53100"
          x1="7.39966"
          y1="15"
          x2="22.5997"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F4C074" />
          <stop offset="0.34" stop-color="#E3B16A" />
          <stop offset="1" stop-color="#BE7B2B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
